/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
/* eslint-disable max-len */
import React, { useEffect, useMemo } from 'react'
import {useContext ,useState} from "react"
import GlobalContext from '../../../../components/Context/GloablContext'
import Pagination from '../../../../components/Pagination'
import Limit from '../../../../components/Limit'
import CustomOverLay from '../../../../components/CustomOverLay'
import SearchEmptyScreen from '../../../../components/SearchEmptyScreen'
import BloodGlouseVitalTable from './Components/Table'
import { motion } from 'framer-motion'
import moment from 'moment'
import Emptyscreenwithouttitle from '../../../../components/Emptyscreenwithouttitle'
import { Link, useLocation, useSearchParams } from 'react-router-dom'
import { useExportDeviceVitalReadingListMutation, useVitalReadingListQuery ,useGetPatientWellnessDetailsQuery} from '../../../../slices/patientSlice'
import BloodGlouseVitalTopBar from './Components/Topbar'
import { handleAddFilterValues } from '../../../../redux/systemConfigSlice'
import { useDispatch, useSelector } from 'react-redux'
import TopHeader from '../../../../components/TopHeader'
import HelpGuideModal from '../../../../components/HelpGuideModal'
import {useGetHelpGuideProviderQuery} from '../../../../slices/patientSlice'
import DeviceAlertDashboardSearch from '../../../ManageDashboard/AlertsList/AdvancedSearch'
import { resetDeviceAlertDashboardSearch, setDeviceAlertDashboardSearchApplied } from '../../../../redux/deviceAleartDashboardSlice'

export default function BloodGlouseVitalList({device}) {
    const [exportDeviceVitalDetails]= useExportDeviceVitalReadingListMutation()
    const deviceDashboardSearch = useSelector(state => state.deviceAlertDashboardSearchData);
    const location = useLocation()

    const [navigationState, setNavigationState] = useState(() => location.state);
    useEffect(() => {
        if (location.state !== undefined && location.state !== null) {
            setNavigationState(location.state);
        }
    }, [location.state]);

    const cameFromContactHistory = useMemo(() => {
        const state = navigationState;
        if (!state) return false;

        if (typeof state === 'string') {
            return state === 'contact_history';
        }

        if (Array.isArray(state)) {
            return state.includes('contact_history');
        }

        if (typeof state === 'object') {
            if (state.cameFrom === 'contact_history') return true;
            if (state.state && typeof state.state === 'object') {
                return state.state.cameFrom === 'contact_history';
            }
        }

        return false;
    }, [navigationState]);

    const contactHistoryLink = useMemo(() => {
        if (!cameFromContactHistory) return null;
        const pathSegments = location.pathname?.split('/') || [];
        const state = navigationState && typeof navigationState === 'object' && !Array.isArray(navigationState) ? navigationState : {};
        const viewPatientId = state?.id || pathSegments?.[3];
        const patientUniqueId = state?.patientId || pathSegments?.[6] || pathSegments?.[5];

        if (!viewPatientId || !patientUniqueId) return null;

        return `/manage-patients/view-patient/contact-history/${viewPatientId}/${patientUniqueId}`;
    }, [cameFromContactHistory, location.pathname, navigationState]);

    const [isColumnSelect,setIsColumnSelect] = useState(false)
    const initialState={
        "filter_start_date":'',
        "filter_end_date":'',
    }
    const [isSortselected,setisSortSelected]=useState(false)
    const [datePartialFilled,setDatePartialFilled]=useState(false)
    const [filterValues,setFilterValues]=useState(initialState)
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [searchParams,setSearchParams] = useSearchParams()

    const {data,isFetching,status}=useVitalReadingListQuery( searchParams.toString(),{skip:!searchParams.get('patient_id') || searchParams.size < 4,refetchOnMountOrArgChange:true})
    const {data:wellnessDetails} = useGetPatientWellnessDetailsQuery(location?.pathname?.split('/')?.[6])

    const dispatch = useDispatch()
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsorg, setQueryParamsorg] = useState('')
    const userType = sessionStorage.getItem('user_type')
    const {isSideBar,setToastmessage,setToastErrorMessage, setIsSearchOpen, isSearchOpen, setIsSideBar} = useContext(GlobalContext);


    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideProviderQuery(queryParamsorg, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    const handleApplyFilter=(type)=>{
        let params = Object.fromEntries(searchParams);
        const start_date=moment(filterValues.filter_start_date).format('YYYY-MM-DD')
        const end_date=moment(filterValues.filter_end_date).format('YYYY-MM-DD')
        dispatch(handleAddFilterValues({
            "filter_start_date":filterValues.filter_start_date,
            "filter_end_date":filterValues.filter_end_date,

        }))
        if(type){
            params.page_number=1
            filterValues?.filter_start_date!==""&&filterValues?.filter_start_date!==undefined?params["start_date"]=start_date:''
            filterValues?.filter_end_date!==""&&filterValues?.filter_end_date!==undefined?params["end_date"]=end_date:''
            setSearchParams({...params})
        }
        else{
            params.start_date&&delete params.start_date
            params.end_date&&delete params.end_date
            setSearchParams({ ...params})
        } 
    }
    const [limit,setLimit]=useState("15")

    function handleNoOfRowsClick(number) {
        // setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });
    }
    const handleOnClickPageNumber = (pageNum) => {
        // setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })
        // dispatch(addToTopCheckbox([pageNum.selected+1,searchParams.get("limit")]))
    }

    useEffect(() => {
        const patientId = device===undefined ? location.pathname.split('/')?.[5] : location.pathname.split('/')?.[6];
        
        let params = Object.fromEntries(searchParams);
        
        // Always ensure required params are set
        if (!params.limit) params.limit = '15';
        if (!params.page_number) params.page_number = '1';
        if (!params.reading_type) params.reading_type = 'all';
        if (!params.filter) params.filter = 'true';
        if (!params.type) params.type = 'readings';
        if (!params.patient_id && patientId) params.patient_id = patientId;
        if (!params.last_id) params.last_id = null;
        if (!params.last_page) params.last_page = null;
        if (!params.last_sort_value) params.last_sort_value = null;
        
        // Update sort if needed
        if (!params.sort || params.sort === '_id+asc' || params.sort === '_id%2Basc' || params.sort === '_id+desc' || params.sort === '_id%2Bdesc') {
            params.sort = 'measurement_date_time+desc';
        }
        
        setSearchParams(params);
    }, [location.state,device]);

    useEffect(() => {
        if (userType === 'monitor-user') {
            setQueryParamsorg('type=monitor-reading-history');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsorg) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsorg]);

    const handleOnSubmit = (e) => {
        
        e.preventDefault();
    
        let searchString = '';
        
        // Utility function to handle __NULL__ logic for search values
        const formatSearchValue = (value) => {
            const trimmedValue = value.trim();
            return trimmedValue === '-' ? '__NULL__' : trimmedValue;
        };

        // Check for `device_id` and `device_id_inverse` conditions
        if (deviceDashboardSearch?.device_id && deviceDashboardSearch.device_id.trim() !== '') {
            const deviceIdPrefix = deviceDashboardSearch.device_id_inverse ? 'ne:' : '';
            const formattedDeviceId = formatSearchValue(deviceDashboardSearch.device_id);
            searchString += `device_id=${deviceIdPrefix}${encodeURIComponent(formattedDeviceId)};`;
        }

        // Check for `threshold` and `threshold_inverse` conditions
        if (deviceDashboardSearch?.threshold && deviceDashboardSearch.threshold.trim() !== '') {
            const thresholdPrefix = deviceDashboardSearch.threshold_inverse ? 'ne:' : '';
            const formattedThreshold = formatSearchValue(deviceDashboardSearch.threshold);
            searchString += `threshold=${thresholdPrefix}${encodeURIComponent(formattedThreshold)};`;
        }

        // Check for `reading` and `reading_inverse` conditions
        if (deviceDashboardSearch?.reading && deviceDashboardSearch.reading.trim() !== '') {
            const readingsPrefix = deviceDashboardSearch.reading_inverse ? 'ne:' : '';
            const formattedReadings = formatSearchValue(deviceDashboardSearch.reading);
            searchString += `reading=${readingsPrefix}${encodeURIComponent(formattedReadings)};`;
        }

        // check for alert_type field
        if (deviceDashboardSearch?.alert_type) {
            const alertTypePrefix = deviceDashboardSearch.alert_type_inverse ? 'ne:' : '';
            const formattedAlertType = formatSearchValue(deviceDashboardSearch.alert_type);
            searchString += `alert_type=${alertTypePrefix}${encodeURIComponent(formattedAlertType)};`;
        }

        // check for reading_type field
        if (deviceDashboardSearch?.reading_type) {
            const readingTypePrefix = deviceDashboardSearch.reading_type_inverse ? 'ne:' : '';
            const formattedReadingType = formatSearchValue(deviceDashboardSearch.reading_type)
                .toLowerCase() 
                .replace(/\s+/g, '_');
            searchString += `reading_type=${readingTypePrefix}${encodeURIComponent(formattedReadingType)};`;
        }

        // check for reading_details field (now in search string, supports inverse)
        if (deviceDashboardSearch?.reading_details && deviceDashboardSearch.reading_details.trim() !== '') {
            const readingDetailsPrefix = deviceDashboardSearch.reading_details_inverse === 'true' ? 'ne:' : '';
            const formattedReadingDetails = formatSearchValue(deviceDashboardSearch.reading_details);
            searchString += `reading_details=${readingDetailsPrefix}${encodeURIComponent(formattedReadingDetails)};`;
        }

        searchString = searchString.endsWith(';') ? searchString.slice(0, -1) : searchString;

        // Get patient ID for required params
        const patientId = device===undefined ? location.pathname.split('/')?.[5] : location.pathname.split('/')?.[6];
        
        // Merge all search parameters into a single object
        const currentParams = Object.fromEntries(searchParams); // Get existing params
        const newParams = {
            ...currentParams, // Preserve existing params (limit, sort, etc.)
            search: searchString || '', // Add search string
            search_mode: deviceDashboardSearch.match === false ? 'and' : 'or', // Add search mode
            page_number: 1, // Reset page number on new search
            limit: currentParams.limit || '15', // Keep limit or set default
            // Ensure all required params are present
            reading_type: currentParams.reading_type || 'all',
            filter: currentParams.filter || 'true',
            type: currentParams.type || 'readings',
            patient_id: currentParams.patient_id || patientId,
            sort: currentParams.sort || 'measurement_date_time+desc',
            // Reset pagination params
            last_id: null,
            last_page: null,
            last_sort_value: null
        };
    
        // Remove reading_details from direct query params (now handled in search string)
        delete newParams.reading_details;
    
        // Remove empty search key if search string is empty
        if (!newParams.search) delete newParams.search;
    
        // Set searchApplied flag BEFORE updating searchParams to prevent race condition
        dispatch(setDeviceAlertDashboardSearchApplied());
        
        // Update all searchParams in one go to avoid multiple re-renders or API calls
        setSearchParams(newParams);
        setisSortSelected(false);
    };

    return (
        <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
            <TopHeader title={`${device===undefined?'Vital':'Device'} Reading History`}/>
           
            <div className='bg-white rounded-lg pt-3 h-customh3 relative'> 
                <div className="flex items-center ml-[28px] mb-3">
                    <>
                        <Link 
                            to="/manage-patients" 
                            state={Array.isArray(navigationState)?'':navigationState}
                            onClick={() => { dispatch(resetDeviceAlertDashboardSearch()),
                            setIsSearchOpen(false)}}>
                            <h1 className="text-sm font-normal text-[#52555D]">List of Patients</h1>
                        </Link>
                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                        <Link 
                            to={`/manage-patients/view-patient/${device===undefined?location.pathname.split('/')?.[3]:location.pathname.split('/')?.[3]}`} 
                            state={`${device===undefined?'vital_screen':'device_screen'}`} 
                            className='items-center min-w-max flex'
                            onClick={() => { dispatch(resetDeviceAlertDashboardSearch()),
                            setIsSearchOpen(false)}}>
                            <h1 className="text-sm font-normal text-[#52555D]">View Patient</h1>
                        </Link>
                        { (cameFromContactHistory && contactHistoryLink) &&
                        <>
                            <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                            <Link
                                to={contactHistoryLink}
                                
                            >
                                <h1 className="text-sm font-normal text-[#52555D]">Patient Contact Management</h1>
                            </Link>
                        </>
                        }
                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                        {device===undefined?<h1 className="text-sm font-normal text-[#008586]">View Vital History</h1>:<h1 className="text-sm font-normal text-[#008586]">List of Device Reading History</h1>}
                        <span   onClick={() => setHelpGuideModel(true)} className=' ml-auto mr-6 cursor-pointer'>
                            <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                        </span> 
                    </>
                </div>      
                <div className="px-6">
                    {data!==undefined&&!isFetching&&<BloodGlouseVitalTopBar
                        device={device}
                        SearchInput={false }
                        ApplyFilter={(searchParams.get("start_date")===null&&searchParams.get("end_date")===null&&(data?.historical_reading?.length===0 || data===undefined)) ? false : true}
                        handleApplyFilter={handleApplyFilter}
                        data={data}
                        exportCols={device===undefined?['Timestamp','Vital Type','Reading','Threshold','Device ID']:['Timestamp','Reading Type','Reading','Alert Type', 'Reading Details','Threshold','Device ID']}
                        filterValues={filterValues}
                        setFilterValues={setFilterValues}
                        isColumnSelect={isColumnSelect}
                        setIsColumnSelect={setIsColumnSelect}
                        initialState={initialState}
                        exportVitalDetails={exportDeviceVitalDetails}
                        isFilterOpen={isFilterOpen}
                        setIsFilterOpen={setIsFilterOpen}
                        wellnessDetails={wellnessDetails}
                        TotalCount={parseInt(data?.total_count)}
                        deviceReadingSearch={true}

                    />}
                </div>
                {((isFetching&&status!=="fulfilled"&&status!=="rejected")||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text={device===undefined?`Loading Vital Reading History...`:`Loading Device Reading History...`} classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar?'opened_sidebar_overlay':'overlay-list'}`}/>: (data!==undefined && data?.historical_reading?.length > 0 ) ? <>   
                    <div className="px-6">
                        <BloodGlouseVitalTable
                            pageNumber={Number(searchParams.get('page_number')) || 1}
                            List={data}
                            device={device}
                            wellnessDetails={wellnessDetails}
                            handleSearchParams={handleSearchParams}
                        />
                    </div>
                    {data?.total_count>=15&&<div className="w-full px-2.5 pt-1 flex items-center justify-between bg-[#F4F7FC] rounded-b-lg">
                        <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                        <div className="flex items-center">
                            <Limit
                                limit={limit}
                                setLimit={setLimit}
                                handleNoOfRowsClick={handleNoOfRowsClick}
                            />
                            <Pagination
                                TotalCount={parseInt(data?.total_count)}
                                totalPageNumber={Math.ceil(parseInt(data?.total_count)/parseInt(searchParams?.get("limit")))}
                                handleOnClickPageNumber={handleOnClickPageNumber}
                                // limit={Number(searchParams.get('limit'))}
                                limit={parseInt(limit)}
                            />
                        </div>
                    </div>}
                </>:<>
                    {(data?.total_count === 0 && (searchParams.get('search') || searchParams.get('search_mode'))) ? (
                        <SearchEmptyScreen text={"No exact matches found. Please try a different search"} />
                    ):
                        data?.historical_reading?.length===0 && (searchParams.get("start_date")!==null||searchParams.get("end_date")!==null) ?
                            <SearchEmptyScreen 
                                vitalFilterHeight={true}
                                text={"That filter combination has no result. Please try different criteria"} 
                            />
                            :
                            (data?.total_count===0?<Emptyscreenwithouttitle
                                FirstPTag={`No ${device===undefined?'vital':'device'} reading history to view yet`}
                                vitalHeight={true}
                            />
                                :((status==="rejected"||(data?.total_count!==0&&data?.historical_reading?.length===0))&&<SearchEmptyScreen text={"No data found"} />)
                            )
                    }
                </>}
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
                }
                {isSearchOpen &&
                <DeviceAlertDashboardSearch
                    handleOnSubmit={handleOnSubmit}
                    emptyField={datePartialFilled}
                    setEmptyField={setDatePartialFilled}
                    DeviceReadingList={true}
                />
                }
            </div>
        </div>
            
          
    )
}
